import { Component, Input } from '@angular/core';
import { BrowserService } from 'src/app/core/browser.service';

const iconRetinaUrl = 'assets/marker-icon-2x.png';
const iconUrl = 'assets/marker-icon.png';
const shadowUrl = 'assets/marker-shadow.png';
@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrl: './map.component.scss',
})
export class MapComponent {
  private map!: L.Map;
  @Input() latitude!: number;
  @Input() longitute!: number;

  constructor(private readonly _browserService: BrowserService) {}

  async ngOnInit(){
    if (this._browserService.isBrowserPlatform()) {
      const L = await import('leaflet'); // Lazy load Leaflet
      const map = L.map('map').setView([51.505, -0.09], 13);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);
    }
  }

  ngAfterViewInit(): void {
    if(this._browserService.isBrowserPlatform()){
      this.initMap();
    }
  }

  private async initMap() {
    if(this._browserService.isBrowserPlatform()){
      const L = await import('leaflet'); // Lazy load Leaflet
      const iconDefault = L.icon({
        iconRetinaUrl,
        iconUrl,
        shadowUrl,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        tooltipAnchor: [16, -28],
        shadowSize: [41, 41],
      });
      L.Marker.prototype.options.icon = iconDefault;
      this.map = L.map('map', {
        attributionControl: false,
        center: [this.latitude, this.longitute],
        zoom: 10,
      });

      const tiles = L.tileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          maxZoom: 18,
          minZoom: 3,
          // attribution: '<a href="">OpenStreetMap</a>'
        },
      );

      tiles.addTo(this.map);
      this.addMarker(L,this.map, this.longitute, this.latitude);
    }
  }

  addMarker(L: any ,map: L.Map, logitude: number, latitude: number): void {
    const lon = logitude;
    const lat = latitude;
    const marker = L.marker([lat, lon]);

    marker.addTo(map);
  }
}
